<template>
	<v-col class="reward">
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">List Reward</div>
		</div>

		<div class="mt-5">
			<v-row>
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
						<v-tabs class="tabs-vo no-slider">
							<v-tab elevation="2" @click="showReward = 'rewardNode'">
								<template v-if="showReward === 'rewardNode'">
									<v-icon dense class="mr-1">mdi-medal-outline</v-icon>
								</template>Reward Titik
							</v-tab>
							<template v-if="false">
								<v-tab elevation="2" @click="showReward = 'rewardTour'">
									<template v-if="showReward === 'rewardTour'">
										<v-icon dense class="mr-1">mdi-medal-outline</v-icon>
									</template>Reward Tour
								</v-tab>
							</template>
						</v-tabs>
					</v-card>
				</v-col>
			</v-row>
		</div>

		<template v-if="!loading">
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="mt-5" v-if="showReward === 'rewardNode'">
					<ListRewardTitik></ListRewardTitik>
				</div>
				<div class="mt-5" v-if="showReward === 'rewardTour'">
					<ListRewardTour></ListRewardTour>
				</div>
			</v-scroll-x-reverse-transition>
		</template>

		<template v-else>
			<v-row>
				<v-col cols="12" sm="12" md="12">
					<LoadData :loading="loading"></LoadData>
				</v-col>
			</v-row>
		</template>
	</v-col>
</template>

<script>
import ListRewardTitik from './components/ListRewardTitik';
import ListRewardTour from './components/ListRewardTour';

export default {
	components: {
		ListRewardTitik, ListRewardTour,
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			showReward: 'rewardNode',
		}
	},
	computed: {
	},
	methods: {
	},
	created() {
		this.$store.dispatch('setPageTitle', `List Reward Tour`)
	}
};
</script>

